import { createContext, useContext, useState, useCallback } from 'react';

export const MODALS = {
    CREDIT_CHECK: 'CreditCheckModal',
    SIMULATION_TYPE: 'SimulationTypeModal',
    DIFFICULTY_SELECTION: 'DifficultySelectionModal',
    PRODUCT_SUMMARY: 'ProductSummaryModal',
    PRODUCT_SUMMARY_REVIEW: 'ProductSummaryReviewModal',
    PERSONA_PROFILE: 'PersonaProfileSelection',
    INVITE_DIALOG: 'InviteDialog',
    PROFILE_SETUP: 'ProfileSetupModal',
    UPGRADE: 'UpgradeModal',
    TARGET_SEGMENT: 'TargetSegmentModal', // Added
    SEGMENT_CONFIGURATION: 'SegmentConfigurationModal', // Added
};

const ModalContext = createContext();

export function ModalProvider({ children }) {
    const [openModal, setOpenModal] = useState(null);
    const [nextModal, setNextModal] = useState(null);

    const closeModal = useCallback(() => setOpenModal(null), []);

    return (
        <ModalContext.Provider value={{ openModal, setOpenModal, nextModal, setNextModal, closeModal }}>
            {children}
        </ModalContext.Provider>
    );
}

export function useModal() {
    return useContext(ModalContext);
}
